import { PermissionsType } from '@/common/permissionsConst';
import MicrogridTopologyModeling from '.';

const routes = [
  {
    path: '/microgrid/topology/modeling',
    permission: PermissionsType.P_MICROGRID_TOPOLOGY_MODELING,
    element: <MicrogridTopologyModeling />,
  },
];

export default routes;
